<template>
  <div class="col-12 p-4 bg-white hrflow_content_container">
    <div class="title">
      <p class="h4">{{ model.name }}</p>
      <div class="m-0 row">
        <p class="whiteSpaceWrap">
          <a
              v-if="model.url"
              target="_blank"
              :href="model.url"
              class="p-0 job_url"
            >
              {{ model.url ? jobUrlFormatter(model.url) : '' }}
          </a>
          <span v-if="model.url && model.reference" class="dot_container mx-2" />

          {{ model.reference ? model.reference : '' }}
          <span v-if="model.url || model.reference && model.location && model.location.text" class="dot_container mx-2" />

          {{ model.location && model.location.text ? model.location.text : '' }}
          <span v-if="model.url || model.reference || model.location || model.location.text && model.created_at" class="dot_container mx-2" />

          {{ jobDateFormatter(model.created_at) }}
        </p>
      </div>
    </div>
    <div class="body pt-4">
      <div class="col-12 px-0">
        <h6>Summary</h6>
        <p v-html="model.summary" />
      </div>
      <div class="col-12 px-0 pt-2" v-if="model.skills && model.skills.length">
        <h6>Required skill(s):</h6>
        <ul v-if="model.skills && model.skills.length">
          <li
            v-for="(skill, idx) in model.skills"
            :key="idx"
          >
            {{ skill.name }}
          </li>
        </ul>
        <div class="mb-1rem" v-else>No required skill(s) available.</div>
      </div>
      <div class="col-12 px-0 pt-2" v-if="model.tasks && model.tasks.length">
        <h6>Task(s):</h6>
        <ul v-if="model.tasks && model.tasks.length">
          <li
            v-for="(task, idx) in model.tasks"
            :key="idx"
          >
            {{ task.name }}
          </li>
        </ul>
        <div class="mb-1rem" v-else>No required taks(s) available.</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment'

export default {
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      model: {}
    }
  },
  computed: {
    job() {
      let parameters = this.parameters || {}
      return parameters.job || {}
    }
  },
  methods: {
    jobUrlFormatter(str) {
      let string = str || ''
      let index = string.indexOf('/')
      let com = string.lastIndexOf('.com')

      if (index != -1) index = index + 2
      else index = 0

      if (com != -1) com = com + 4
      else com = 0

      return string.slice(index, com)
    },
    jobDateFormatter(createdAt) {
      let dateNow = moment(new Date())
      let dateEnd = moment(createdAt)
      let duration = moment.duration(dateNow.diff(dateEnd));
      let finalDate

      if (new Date().getMonth() === new Date(createdAt).getMonth()) {

        if (
          new Date().getDate() === new Date(createdAt).getDate()
        ) {
          finalDate = `${Math.round(duration.asMinutes())} minute(s) ago`
        }
        else if (
          new Date().getDate() === new Date(createdAt).getDate()
        ) {
          finalDate = `${Math.round(duration.asHours())} hour(s) ago`
        }
        else if (
          new Date().getDate() > new Date(createdAt).getDate()
          && (new Date().getDate() - new Date(createdAt).getDate()) <= 6
        ) {
          finalDate = `${Math.round(duration.asDays())} day(s) ago`
        }
        else {
          finalDate = `${Math.round(duration.asWeeks())} week(s) ago`
        }
        
      }
      else if (
        new Date().getMonth() > new Date(createdAt).getMonth()
        && (new Date().getMonth() - new Date(createdAt).getMonth()) <= 11
      ) {
        finalDate = `${Math.round(duration.asMonths())} month(s) ago`
      }
      else {
        finalDate = `${Math.round(duration.asYears())} year(s) ago`
      }

      return finalDate
    }
  },
  mounted() {
    if (this.job && Object.entries(this.job).length) {
      this.model = this.job
      console.log(this.model)
    }
  },
  watch: {
    job: function () {
      this.model = this.job
    }
  }
}
</script>

<style lang="scss">
  .dot_container {
    height: 4px;
    width: 4px;
    border-radius: 50%;
    background: grey;
    display: inline-block;
  }
  .job_url {
    color: #4b4b5a;
    transition: color 0.2s ease-in-out;
  }
  .job_url:hover {
    color: #5369f8!important;
  }
  .mb-1rem {
    margin-bottom: 1rem;
  }
  .hrflow_content_container {
    max-height: 74vh!important;
    overflow: auto;
  }
  
  .whiteSpaceWrap {
    white-space: pre-wrap;
    word-break: break-all;
  }
</style>
